module.exports = __webpack_public_path__ + "img/wordpress_4.4397d459.png";